/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
import React from "react";
import ReactDOM from "react-dom";
import anime from "animejs/lib/anime.es.js";

import { CardBlog } from "../../components/molecules/cardBlog/card-blog-front";

/* eslint-enable no-console */

let cardsContainer = document.querySelector(".swiper-recommended-blog");
const loader = document.querySelector("#loading");

// showing loading
function displayLoading() {
	loader.classList.add("display");
}

// hiding loading
function hideLoading() {
	loader.classList.remove("display");
	loader.style.display = "none";
}
function decodeHTMLEntities(text) {
	var textArea = document.createElement("textarea");
	textArea.innerHTML = text;
	return textArea.value;
}
displayLoading();
fetch(
	`${window.location.origin}/wp-json/wp/v2/categories?per_page=20&hide_empty=true`,
)
	.then((res) => res.json())
	.then((categories) => {
		fetch(
			`${window.location.origin}/wp-json/wp/v2/posts/?per_page=5&_embed=wp:featuredmedia`,
		)
			.then((result) => {
				return result.json();
			})
			.then(async (data) => {
				let cards = data.map((itm, index) => {
					if (itm.link !== window.location.href) {
						return (
							<div className="swiper-slide">
								<CardBlog
									link={itm.link}
									creationDate={itm.date}
									desc={itm.excerpt.rendered}
									tags={itm.categories.map((cat) => {
										let tempCat = categories.find(
											(innerItm) => innerItm.id == cat,
										);

										return {
											openLinkkInNewTab: false,
											href: `blog/?category=${tempCat?.id}`,
											text: tempCat?.name,
										};
									})}
									title={decodeHTMLEntities(itm.title.rendered)}
									icon={
										"/wp-content/themes/sistecredito/assets/img/calendar.svg"
									}
									index={index}
								/>
							</div>
						);
					}
				});
				hideLoading();
				ReactDOM.render(cards.filter(Boolean).slice(0, 3), cardsContainer);
				animateElements();
			});
	});

const animateElements = () => {
	const cards = document.querySelectorAll(
		".swiper-blog-recomended > .swiper-wrapper > .swiper-slide > .sc-card-blog",
	);

	let options = {
		root: null,
		rootMargin: "0px",
		threshold: 0.0,
	};
	function handleCardWatcherEntry(entries, observer) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				animateCards(entry.target);
				observer.unobserve(entry.target);
			}
		});
	}

	const intersectionWathcer = () => {
		let observerCard = new IntersectionObserver(
			handleCardWatcherEntry,
			options,
		);

		cards.forEach((card) => {
			observerCard.observe(card);
		});
	};

	intersectionWathcer();

	const animateCards = (card) => {
		anime({
			targets: card,
			top: "0px",
			opacity: [0, 1],
			easing: "easeOutExpo",
			duration: 500,
			delay: 500,
		});
	};
};

const buttons = document.querySelectorAll(
	".sc-cards-recomended-edit__left-column__button",
);

buttons.forEach((button) => {
	button.addEventListener("click", () => {
		dataLayer.push({
			event: "click",
			name: button.textContent,
			page: window.location.pathname,
			id: button.textContent,
		});
	});
});
